import { FileText } from 'lucide-react';
import type { PortfolioMediaFileType, PortfolioMediaItem } from '../../firebase/types/portfolio.types';
import { Band, SectionIndex } from './ui';

function inferFileType(url: string): PortfolioMediaFileType {
  const lower = url.toLowerCase();
  if (lower.endsWith('.pdf')) return 'pdf';
  if ([/\.webm$/, /\.mp4$/, /\.ogg$/, /\.mov$/].some((pattern) => pattern.test(lower))) return 'video';
  return 'image';
}

export default function MediaSection({ items, index }: { items: PortfolioMediaItem[]; index: string }) {
  const media = items.filter((item) => item?.url?.trim());
  if (!media.length) return null;

  return (
    <Band id="media">
      <SectionIndex index={index} title="Media" />
      <div className="grid gap-8">
        {media.map((item, i) => {
          const type = item.fileType ?? inferFileType(item.url);
          return (
            <figure key={`${item.url}-${i}`} className="overflow-hidden">
              {item.title ? <figcaption className="mb-4 text-lg font-medium">{item.title}</figcaption> : null}
              {type === 'image' ? (
                <img
                  src={item.url}
                  alt={item.title || 'Media'}
                  loading="lazy"
                  className="max-h-[40rem] w-full rounded-3xl border border-line object-cover"
                />
              ) : null}
              {type === 'pdf' ? (
                <a href={item.url} target="_blank" rel="noopener noreferrer" className="text-link inline-flex items-center gap-2">
                  <FileText className="h-4 w-4" aria-hidden="true" />
                  {item.fileName || 'Open PDF'}
                </a>
              ) : null}
              {type === 'video' ? (
                <video src={item.url} controls className="w-full rounded-3xl border border-line" title={item.title} />
              ) : null}
            </figure>
          );
        })}
      </div>
    </Band>
  );
}
